import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from '../styles/Navbar.module.css';
import logo from '../assets/InviteEngineF.png';

const LINKS = [
  { label: 'Home',       to: '/' },
  { label: 'Services',   to: '/services' },
  { label: 'Blog',   to: '/blog' },
  { label: 'About Us',   to: '/about' },
  { label: 'Contact Us', to: '/contact', cta: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => { setMenuOpen(false); }, [location]);

  const isActive = (to) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <nav className={`${styles.navbar}${scrolled ? ` ${styles.scrolled}` : ''}`}>
      <div className="container">
        <div className={styles.inner}>
          <Link to="/" className={styles.brand}>
             <img src={logo} alt="InviteEngine" className={styles.logo} />
          </Link>

          <ul className={styles.navLinks}>
            {LINKS.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  className={`${styles.navLink}${isActive(l.to) ? ` ${styles.active}` : ''}${l.cta ? ` ${styles.navCta}` : ''}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>

          <button
            className={styles.hamburger}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle navigation"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        {menuOpen && (
          <div className={styles.mobileMenu}>
            {LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className={`${styles.mobileLink}${isActive(l.to) ? ` ${styles.active}` : ''}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
